module.exports = __webpack_public_path__ + "static/media/chevron-right.0b593f1e.svg";